import { useEffect } from 'react';
import { useApiQuery } from '../../api/hooks';
import { useDemocracyModeStore } from '../../stores';
import { Endpoints, QueryKey, DemocracyMode } from './constants';

export default function useDemocracyMode() {
    const setInfo = useDemocracyModeStore((s) => s.setInfo);
    const mode = useDemocracyModeStore((s) => s.mode);
    const loaded = useDemocracyModeStore((s) => s.loaded);
    const version = useDemocracyModeStore((s) => s.version);
    const campCode = useDemocracyModeStore((s) => s.campCode);
    const hasActiveSession = useDemocracyModeStore((s) => s.hasActiveSession);

    const { data, isLoading, error } = useApiQuery(
        QueryKey.publicInfo,
        Endpoints.publicInfo,
        { staleTime: Infinity, enabled: !loaded }
    );

    useEffect(() => {
        if (data && !loaded) {
            setInfo(data);
        }
    }, [data, loaded, setInfo]);

    return {
        mode,
        version,
        campCode,
        hasActiveSession,
        loaded,
        isLoading,
        error,
        isOnline: mode === DemocracyMode.K8S,
        isStandalone: mode === DemocracyMode.STANDALONE,
    };
}
